import React, { ChangeEvent, Component, useContext, useState } from "react";
import "./QboPullEstimatesModal.scss";
import OwButton from "../../shared/OwButton/OwButton";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import ISupplierModel from "../../../models/ISupplierModel";
import OwTitle from "../../shared/OwTitle/OwTitle";
import IUserUI from "../../../models/IUserUI";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import OwLabel from "../../shared/OwLabel/OwLabel";
import { OwFnInput } from "../../shared/OwFnInput/OwFnInput";
import IQBOPullEstimatesDTO from "../../../models/DTO/IQBOPullEstimatesDTO";
import OwDateInput from "../../shared/OwDateInput/OwDateInput";
import moment from "moment-timezone";
import UserService from "../../../services/UserService";
import { Socket } from "socket.io-client";

type Props = {
    closeModalFn: () => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    performPull: (payload: IQBOPullEstimatesDTO) => void;
};

export const QboPullEstimatesModal: React.FC<Props> = (props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const [lastDate, setLastDate] = useState<moment.Moment>();
    const [docNumber, setDocNumber] = useState<string>();

    const closeModal = () => {
        props.closeModalFn();
    };

    const handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.value;
        const name = e.target.name;

        setDocNumber(value);
    };

    const handleDateChange = (e: moment.Moment) => {
        setLastDate(e);
    };

    const performPull = () => {
        const payload: IQBOPullEstimatesDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
        };

        if (docNumber && docNumber.length) {
            payload.docNumber = docNumber;
        } else {
            if (lastDate) {
                payload.lastDate = lastDate.format("YYYY-MM-DD");
            }
        }

        props.performPull(payload);
        props.closeModalFn();
    };

    return (
        <div className={"QboPullEstimatesModal p-2"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle leftIconName={"fad fa-cloud-download-alt"} title={"pull_estimates"} tag={"h3"} />
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={closeModal} />
                    </div>
                </div>
            </div>

            <div>
                {docNumber?.length ? null : (
                    <div>
                        <OwLabel title={"pulling_from"} postText={":"} className={"me-2"} />
                        {lastDate
                            ? lastDate.format("MM-DD-YYYY")
                            : UserService.parseLastUpdated(supplierModel.Supplier_Integration.qbo_LastEstimatePullDate)}
                    </div>
                )}
                <div className={"mt-3"}>
                    <OwLabel title={"name"} />
                    <OwFnInput fn={handleChange} name={"docNumber"} value={docNumber} />
                </div>
                <div className={"mt-3"}>
                    <OwLabel title={"last_date"} />
                    <OwDateInput fn={handleDateChange} dateFormat={"MM-dd-yyyy"} selectedDate={lastDate} disabled={!!docNumber?.length} />
                </div>
                <div className={"mt-3"}>
                    <OwButton title={"start"} fn={performPull} />
                </div>
            </div>
        </div>
    );
};
